import * as yup from 'yup'
import { CompanyDto } from './companyDto'

export class CompanyRatesDto {
  copyRatesFromAnotherCompany?: boolean = false
  company?: CompanyDto = undefined
  ratesImportCharge?: number = undefined
  ratesIncomingTransportation?: number = undefined
  ratesClusterConversion?: number = undefined
  ratesClusterProgramming?: number = undefined
  ratesRecallExpenses?: number = undefined
  ratesTitleFees?: number = undefined
  ratesOutboundTransportation?: number = undefined
}

export const companyRatesValidationSchema = yup.object<CompanyRatesDto>({
  ratesImportCharge: yup
    .number()
    .min(0.0, 'Import Charge cannot be less than $0.00.')
    .max(999_999_999_999_999.99, 'Import Charge cannot be more than $999,999,999,999,999.99.')
    .required('Import Charge is required.'),
  ratesIncomingTransportation: yup
    .number()
    .min(0.0, 'Incoming Transportation cannot be less than $0.00.')
    .max(999_999_999_999_999.99, 'Incoming Transportation cannot be more than $999,999,999,999,999.99.')
    .required('Incoming Transportation is required.'),
  ratesClusterConversion: yup
    .number()
    .min(0.0, 'Cluster Conversion cannot be less than $0.00.')
    .max(999_999_999_999_999.99, 'Cluster Conversion cannot be more than $999,999,999,999,999.99.')
    .required('Cluster Conversion is required.'),
  ratesClusterProgramming: yup
    .number()
    .min(0.0, 'Cluster Programming cannot be less than $0.00.')
    .max(999_999_999_999_999.99, 'Cluster Programming cannot be more than $999,999,999,999,999.99.')
    .required('Cluster Programming is required.'),
  ratesRecallExpenses: yup
    .number()
    .min(0.0, 'Recall Expenses cannot be less than $0.00.')
    .max(999_999_999_999_999.99, 'Recall Expenses cannot be more than $999,999,999,999,999.99.')
    .required('Recall Expenses is required.'),
  ratesTitleFees: yup
    .number()
    .min(0.0, 'Title Fees cannot be less than $0.00.')
    .max(999_999_999_999_999.99, 'Title Fees cannot be more than $999,999,999,999,999.99.')
    .required('Title Fees is required.'),
  ratesOutboundTransportation: yup
    .number()
    .min(0.0, 'Outbound Transportation cannot be less than $0.00.')
    .max(999_999_999_999_999.99, 'Outbound Transportation cannot be more than $999,999,999,999,999.99.')
    .required('Outbound Transportation is required.')
})
